// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"d310c46c","formTitleContainer":"eb4496f3","savingIndicator":"fc91be63","check":"e50a8e52","error":"ee50cbd0","formTitle":"b29632eb"};